import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactTooltip from 'react-tooltip'
import ReactGA from 'react-ga';
const { proxy } = require('../../ip_api.config')

class Acc_PreviewItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            isLoading: false,
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            value_serach: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/PreviewItem');

        if (localStorage.getItem("ID_User") !== null) {
            this.getItem_Preview()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getItem_Preview = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []
        let url = proxy.server + '/acc/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.value_serach
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' style={{ fontSize: 14 }} onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button>}</td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.EcoResProductTranslation_LanguageId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.DisplayProductNumber}</td>
                            <td>{val.EcoResProductTranslation_Name}</td>
                            <td>{val.EcoResProductTranslation_Description}</td>
                            <td>{val.SearchName}</td>
                            <td>{val.NameAlias}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.ProductType}</td>
                            <td>{val.ProductSubType}</td>
                            <td>{val.EcoResStorageDimensionGroup_Name}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ModelGroupId}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.ReqGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModuleInvent_PriceUnit}</td>
                            <td>{val.InventTableModuleInvent_PriceQty}</td>
                            <td>{val.CostModel}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_PriceUnit}</td>
                            <td>{val.InventTableModulePurch_PriceQty}</td>
                            <td>{val.PurchModel}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.ItemBuyerGroupId}</td>
                            <td>{val.InventTableModulePurch_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.InventTableModuleSales_PriceUnit}</td>
                            <td>{val.InventTableModuleSales_PriceQty}</td>
                            <td>{val.InventTableModuleSales_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_LineDisc}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.BOMCalcGroupId}</td>
                            <td>{val.DefaultDimension}</td>
                            <td>{val.PdsVendorCheckItem}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.PurchInventLocationId}</td>
                            <td>{val.ItemInventLocationId}</td>
                            <td>{val.SalesInventLocationId}</td>
                            <td>{val.ECL_ItemCategoryIdG1}</td>
                            <td>{val.ECL_ItemCategoryIdG2}</td>
                            <td>{val.ECL_ItemCategoryIdG3}</td>
                            <td>{val.ECL_ItemCategoryIdG4}</td>
                            <td>{val.ECL_ItemCategoryIdBrand1}</td>
                            <td>{val.ECL_ItemCategoryIdBrand2}</td>
                            <td>{val.ECL_ItemCategoryIdBrand3}</td>
                            <td>{val.ECL_ItemCategoryIdBrand4}</td>
                            <td>{val.EXTERNALITEMID}</td>
                            <td>{val.Image}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false, arr_save: responseJson.result })
            })
    }

    getItem_Edit = () => {
        this.setState({ isLoading: true, onPage: 'Edit' })
        let arr = []
        let url = proxy.server + '/acc/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: ''
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }} data-tip="เลือกแถวที่ต้องการแก้ไข">
                                <bs4.Col>
                                    <ReactTooltip />
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                </bs4.Col>
                            </td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.EcoResProductTranslation_LanguageId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.DisplayProductNumber}</td>
                            <td>{val.EcoResProductTranslation_Name}</td>
                            <td>{val.EcoResProductTranslation_Description}</td>
                            <td>{val.SearchName}</td>
                            <td>{val.NameAlias}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.ProductType}</td>
                            <td>{val.ProductSubType}</td>
                            <td>{val.EcoResStorageDimensionGroup_Name}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ModelGroupId}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.ReqGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModuleInvent_PriceUnit}</td>
                            <td>{val.InventTableModuleInvent_PriceQty}</td>
                            <td>{val.CostModel}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_PriceUnit}</td>
                            <td>{val.InventTableModulePurch_PriceQty}</td>
                            <td>{val.PurchModel}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.ItemBuyerGroupId}</td>
                            <td>{val.InventTableModulePurch_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.InventTableModuleSales_PriceUnit}</td>
                            <td>{val.InventTableModuleSales_PriceQty}</td>
                            <td>{val.InventTableModuleSales_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_LineDisc}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.BOMCalcGroupId}</td>
                            <td>{val.DefaultDimension}</td>
                            <td>{val.PdsVendorCheckItem}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.PurchInventLocationId}</td>
                            <td>{val.ItemInventLocationId}</td>
                            <td>{val.SalesInventLocationId}</td>
                            <td>{val.ECL_ItemCategoryIdG1}</td>
                            <td>{val.ECL_ItemCategoryIdG2}</td>
                            <td>{val.ECL_ItemCategoryIdG3}</td>
                            <td>{val.ECL_ItemCategoryIdG4}</td>
                            <td>{val.ECL_ItemCategoryIdBrand1}</td>
                            <td>{val.ECL_ItemCategoryIdBrand2}</td>
                            <td>{val.ECL_ItemCategoryIdBrand3}</td>
                            <td>{val.ECL_ItemCategoryIdBrand4}</td>
                            <td>{val.EXTERNALITEMID}</td>
                            <td>{val.Image}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false })
            })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Acc/EditItem',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_item = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/delete_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.getItem_Preview()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    savetoAX = () => {
        // console.log('arr_save', this.state.arr_save)
        let arr_dpl = this.state.arr_save.filter(x => x.db_name === 'DPL')
        if (arr_dpl.length === 0) {
            alert('ไม่มี Item DPL ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPL จำนวน ${arr_dpl.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/Acc/insert_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpl)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getItem_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    savetoAXDPT = () => {
        let arr_dpt = this.state.arr_save.filter(x => x.db_name === 'DPT')
        if (arr_dpt.length === 0) {
            alert('ไม่มี Item DPT ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPT จำนวน ${arr_dpt.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/Acc/dpt/insert_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpt)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getItem_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_PreviewItem'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Col sm='4'>
                        <bs4.Input style={{ marginLeft: 10 }} type='select' onChange={(e) => this.setState({ value_serach: e.target.value }, () => { this.getItem_Preview() })}>
                            <option value=''>CREATED</option>
                            <option value='IMPORTED'>IMPORTED</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            ? this.state.onPage === 'Preview'
                                ? <div>
                                    <bs4.Button color="secondary" style={{ marginLeft: 10, fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                                    <bs4.Button color="primary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAX()}>IMPORT TO DPL</bs4.Button>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAXDPT()}>IMPORT TO DPT</bs4.Button>
                                </div>
                                : <div>
                                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                    <bs4.Button outline color="secondary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getItem_Preview()}>CANCEL</bs4.Button>
                                </div>
                            : ''
                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐานข้อมูล</th>
                            <th>EcoResProduct<br />Translation_<br />LanguageId</th>
                            <th>ItemId</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Display<br />ProductNumber</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>EcoResProduct<br />Translation_Name</th>
                            <th>EcoResProduct<br />Translation_<br />Description</th>
                            <th>SearchName</th>
                            <th>NameAlias</th>
                            <th>Default<br />OrderType</th>
                            <th>Product<br />Type</th>
                            <th>Product<br />SubType</th>
                            <th>EcoRes<br />StorageDimension<br />Group_Name</th>
                            <th>EcoResTracking<br />Dimension<br />Group_Name</th>
                            <th>Model<br />GroupId</th>
                            <th>Item<br />GroupId</th>
                            <th>Cost<br />GroupId</th>
                            <th>Req<br />GroupId</th>
                            <th>InventTable<br />ModuleInvent_<br />UnitId</th>
                            <th>InventTable<br />ModuleInvent_<br />PriceUnit</th>
                            <th>InventTable<br />ModuleInvent_<br />PriceQty</th>
                            <th>CostModel</th>
                            <th>InventTable<br />ModulePurch_<br />UnitId</th>
                            <th>InventTable<br />ModulePurch_<br />PriceUnit</th>
                            <th>InventTable<br />ModulePurch_<br />PriceQty</th>
                            <th>PurchModel</th>
                            <th>InventTable<br />ModulePurch_<br />OverDeliveryPct</th>
                            <th>ItemBuyer<br />GroupId</th>
                            <th>InventTable<br />ModulePurch_<br />TaxItemGroupId</th>
                            <th>InventTable<br />ModuleSales_<br />UnitId</th>
                            <th>InventTable<br />ModuleSales_<br />PriceUnit</th>
                            <th>InventTable<br />ModuleSales_<br />PriceQty</th>
                            <th>InventTable<br />ModuleSales_<br />TaxItemGroupId</th>
                            <th>InventTable<br />ModuleSales_<br />LineDisc</th>
                            <th>ECL_Number<br />Sequence<br />GroupProd</th>
                            <th>BOMUnitId</th>
                            <th>BOMCalc<br />GroupId</th>
                            <th>Default<br />Dimension</th>
                            <th>PdsVendor<br />CheckItem</th>
                            <th>InventSiteId</th>
                            <th>PurchInvent<br />LocationId</th>
                            <th>ItemInvent<br />LocationId</th>
                            <th>SalesInvent<br />LocationId</th>
                            <th>ECL_Item<br />CategoryIdG1</th>
                            <th>ECL_Item<br />CategoryIdG2</th>
                            <th>ECL_Item<br />CategoryIdG3</th>
                            <th>ECL_Item<br />CategoryIdG4</th>
                            <th>ECL_Item<br />CategoryId<br />Brand1</th>
                            <th>ECL_Item<br />CategoryId<br />Brand2</th>
                            <th>ECL_Item<br />CategoryId<br />Brand3</th>
                            <th>ECL_Item<br />CategoryId<br />Brand4</th>
                            <th>Barcode</th>
                            <th>Image</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_PreviewItem